import { FC, useEffect, useState } from "react";
import { api } from "../../api/axiosClient";
import { getErrorMessage } from "./utils";
import { Category } from "../HomePage/types";

interface SelectLocationProps {
  remote: boolean; //is disabled
  setLocation: Function;
  selectedLocation?: Category;
}

const SelectLocation: FC<SelectLocationProps> = ({
  remote,
  setLocation,
  selectedLocation,
}) => {
  const [locations, setLocations] = useState([]);

  //fetch locations
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await api.get("/accounts/locations/");
        setLocations(response.data);
      } catch (error: any) {
        const message = getErrorMessage(
          error,
          "Błąd podczas pobierania lokalizacji."
        );
        alert(message);
      }
    };
    fetchLocations();
  }, []);

  return (
    <select
      defaultValue={"Wybierz miasto"}
      required
      disabled={remote === true}
      onChange={(e) => {
        const selectedLocation = locations.find(
          (location: Category) => location.id === parseInt(e.target.value)
        );
        if (selectedLocation) {
          setLocation(selectedLocation);
        }
      }}
    >
      <option disabled>Wybierz miasto</option>
      {locations.length > 0 &&
        locations.map((location: Category) => (
          <option
            key={location.id}
            value={location.id}
            selected={location.id === selectedLocation?.id}
          >
            {location.name}
          </option>
        ))}
    </select>
  );
};

export default SelectLocation;
